module.exports = __webpack_public_path__ + "e163f039deabc062873f1f192a9aa021.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/camera.png
// module id = 613
// module chunks = 0